import { createContext , useState } from 'react';

type Props = {
children: any;
};
type utagContextType = {
refPageEvent:string|undefined,
setRef: (newData:string|undefined) => void,
};
const utagContextDefault: utagContextType = {
    refPageEvent:"",
    setRef: (newData:string|undefined) => ({newData}),
};
export const UtagContext = createContext(utagContextDefault);
const UtagContextProvider: React.FC<Props> = ({ children }) => {

const [refPageEvent, setRefPageEvent] = useState<string>();
const setRef =  (newData:string|undefined) => {
    setRefPageEvent(newData)
};
return (
<UtagContext.Provider value={{ refPageEvent,setRef}}>
    {children}
</UtagContext.Provider>
);
};
export default UtagContextProvider;